console.log(
  "WOOD_VARIANTS EXISTS:",
  window.WOOD_VARIANTS
);
window.WOODPricing = (() => {

console.log("WOODPricing loaded");
  const currency = "$";

  window.WOOD_VARIANTS =
  window.WOOD_VARIANTS || {};

const CONFIG =
  window.WOOD_VARIANTS.CONFIG || {};

const variantDatabase =
  window.WOOD_VARIANTS.variantDatabase || {};

const feeVariants =
  window.WOOD_VARIANTS.feeVariants || {};

  function getEls() {
    return window.els || {};
  }

  /* =========================
     LOGO TIER
  ========================= */

  function getLogoTier(colorCount = 0) {

  if (colorCount <= 2) {
    return "simple";
  }

  if (colorCount <= 5) {
    return "moderate";
  }

  if (colorCount <= 8) {
    return "advanced";
  }

  return "complex";
}
  /* =========================
     COLOR UI
  ========================= */

  function updateColorUI() {

  const els = getEls();

  const state =
    window.WOOD_STATE || {};

  if (!els.colorInfoBox) return;

  const colorCount =
    state.cachedColorCount || 0;

    const tier =
      getLogoTier(colorCount);

    const variant =
  variantDatabase.logoComplexity?.[tier];

    const price =
      variant?.price || 0;

    els.colorInfoBox.style.display =
      colorCount > 0 ? "block" : "none";

    if (els.colorCountText) {
      els.colorCountText.textContent =
        `🎨 ${colorCount} colors`;
    }

    if (els.colorPriceText) {
      els.colorPriceText.textContent =
        `+$${price}`;
    }

    if (els.colorComplexityText) {
      els.colorComplexityText.textContent =
        tier.charAt(0).toUpperCase() +
        tier.slice(1);
    }

    if (els.scaleFill) {

      let width = "0%";

      if (tier === "simple") {
      width = "25%";
      }

     if (tier === "moderate") {
     width = "50%";
     }
     if (tier === "advanced") {
     width = "75%";
     }

     

     if (tier === "complex") {
     width = "100%";
     }
     
  if (els.colorSuggestion) {

  if (tier === "simple") {
    els.colorSuggestion.textContent =
      "Great for clean engraving.";
  }

  if (tier === "moderate") {
    els.colorSuggestion.textContent =
      "Moderate detail detected.";
  }
  if (tier === "advanced") {
  els.colorSuggestion.textContent =
    "Advanced logo detail detected.";
}

  

  if (tier === "complex") {
    els.colorSuggestion.textContent =
      "Highly detailed logo detected.";
  }

}

      els.scaleFill.style.width = width;
    }

  }

  /* =========================
     LIVE SUMMARY
  ========================= */

  function updateLiveSummary() {

    const els = getEls();

    if (
      !els.liveSize ||
      !els.sizeSelector ||
      !els.liveShape ||
      !els.liveWood
    ) return;

    const size =
      els.sizeSelector.options[
        els.sizeSelector.selectedIndex
      ]?.text || "";
      

    const shape =
      els.shapeSelector?.value || "";

    const wood =
      els.woodType?.value || "";

    

    els.liveSize.textContent = size;
els.liveShape.textContent = shape;
els.liveWood.textContent = wood;

  }

  /* =========================
     CART PROPERTIES
  ========================= */

  function updateCartProperties() {

    const els = getEls();

    const setVal = (id, value) => {

      const el = document.getElementById(id);

      if (el) {
        el.value = value || "";
      }

    };

    setVal(
      "propText",
      els.textInput?.value
    );

    setVal(
      "propStyle",
      els.textStyle?.value
    );

    setVal(
      "propSize",
      els.sizeSelector?.value
    );

    setVal(
      "propWood",
      els.woodType?.value
    );

    setVal(
      "propLayers",
      els.layerSelector?.value
    );

    setVal(
      "propStain",
      els.stainSelector?.value
    );

    setVal(
      "propRush",
      els.rushOrder?.value
    );

    setVal(
      "propImage",
      els.liveImage?.src
    );

  }
function getTextTier(text = "") {

  const length = text.length;

  if (length <= 10) {
    return "small";
  }

  if (length <= 25) {
    return "medium";
  }

  return "large";
}
  /* =========================
     MAIN PRICE ENGINE
  ========================= */

  function updatePrice() {
  if (!window.WOOD_VARIANTS) {
  console.warn("Variants not loaded yet");
  return;
}  
    const els = getEls();

let selectedAddonVariants = [];

const state = window.WOOD_STATE || {};



  const shape =
    els.shapeSelector?.value;

  const wood =
    els.woodType?.value;

  const size =
    els.sizeSelector?.value;

  console.log("CURRENT SHAPE:", shape);
  console.log("CURRENT WOOD:", wood);
  console.log("CURRENT SIZE:", size);

  const shapeData =
  window.WOOD_VARIANTS.getBaseVariant(
      shape,
      wood,
      size
    );

  console.log("FOUND SHAPE DATA:", shapeData);

  if (!shapeData) {
    console.error("NO SHAPE DATA FOUND");
    return;
  }
const baseTotal =
  parseFloat(shapeData.price) || 0;

const baseVariantId = shapeData.variantId;


    /* =========================
       LAYERS
    ========================= */

    

let layerCost = 0;
let layerVariant = null;
const selectedLayers =
  parseInt(
    els.layerSelector?.value || 1
  );
if (selectedLayers === 2) {
  layerVariant = feeVariants.layer2;
}

if (selectedLayers === 3) {
  layerVariant = feeVariants.layer3;
}

if (selectedLayers === 4) {
  layerVariant = feeVariants.layer4;
}

if (layerVariant) {

  layerCost =
    layerVariant.price || 0;

  selectedAddonVariants.push({
    id: layerVariant.variantId,
    quantity: 1
  });

}

    /* =========================
       STAIN
    ========================= */

    let stainCost = 0;
let stainVariant = null;

const selectedStain =
  (els.stainSelector?.value || "")
    .toLowerCase()
    .trim();

if (selectedStain === "espresso") {
  stainVariant = feeVariants.stainEspresso;
}

if (selectedStain === "grey") {
  stainVariant = feeVariants.stainGrey;
}

if (selectedStain === "black") {
  stainVariant = feeVariants.stainBlack;
}

if (stainVariant) {

  stainCost =
    stainVariant.price || 0;

  selectedAddonVariants.push({
    id: stainVariant.variantId,
    quantity: 1
  });

}

    /* =========================
       TEXT
    ========================= */

    let totalText = "";

if (els.textInput?.value) {
  totalText += els.textInput.value;
}

document
  .querySelectorAll('.draggable-text[data-extra="true"]')
  .forEach(el => {
    totalText += (el.textContent || "").trim();
  });

const cleanText =
  totalText.replace(/\s+/g, "");

const textTier =
  getTextTier(cleanText);

    

    

state.currentTextTier =
  textTier;
    

    const selectedTextStyle =
  (els.textStyle?.value || "flat")
    .toLowerCase()
    .trim();

const textVariant =
  variantDatabase.textStyles?.[
    selectedTextStyle
  ]?.[
    textTier
  ] || null;

    const textCost =
      textVariant?.price || 0;
      
    if (textVariant) {

  selectedAddonVariants.push({
    id: textVariant.variantId,
    quantity: 1
  });

}

    /* =========================
       PAINT
    ========================= */

    let colorCost = 0;
let colorVariant = null;

const activeSwatch =
  document.querySelector(
    ".color-swatch.active"
  );

if (activeSwatch) {

  const color =
    activeSwatch.dataset.color;

  if (color === "#000000") {
    colorVariant = feeVariants.blackPaint;
  }

  if (color === "#ffffff") {
    colorVariant = feeVariants.whitePaint;
  }

  if (color === "#c19a6b") {
    colorVariant = feeVariants.goldPaint;
  }

  if (colorVariant) {

    colorCost =
      colorVariant.price || 0;

    selectedAddonVariants.push({
      id: colorVariant.variantId,
      quantity: 1
    });

  }

}

    /* =========================
       LOGO COMPLEXITY
    ========================= */

    let logoCost = 0;
let logoVariant = null;

const hasLogo =
  !!state.cachedColorCount;

/* IMAGE SIZE PRICING */

let imageSizeCost = 0;

const imageWidth =
  parseInt(
    els.liveImage?.style.width
  ) || 150;

if (imageWidth > 250) {
  imageSizeCost = 20;
}
else if (imageWidth > 200) {
  imageSizeCost = 15;
}
else if (imageWidth > 150) {
  imageSizeCost = 10;
}
else if (imageWidth > 100) {
  imageSizeCost = 5;
}  

if (hasLogo) {

  const logoTier =
    getLogoTier(
      state.cachedColorCount || 0
    );

  logoVariant =
  variantDatabase.logoComplexity?.[
    logoTier
  ];

  logoCost =
    logoVariant?.price || 0;

}
    if (logoVariant) {

  selectedAddonVariants.push({
    id: logoVariant.variantId,
    quantity: 1
  });

}

    /* =========================
       DETAIL
    ========================= */

    let detailCost = 0;

if (els.detailToggle?.checked) {

  detailCost =
    feeVariants.handDetail?.price || 0;

  selectedAddonVariants.push({
    id: feeVariants.handDetail.variantId,
    quantity: 1
  });

}
    /* =========================
       RUSH
    ========================= */

    let rushCost = 0;

const rushType =
  (els.rushOrder?.value || "")
    .toLowerCase()
    .trim();

if (
  rushType === "priority" ||
  rushType === "express"
) {

  rushCost =
    feeVariants.rushOrder?.price || 0;

  selectedAddonVariants.push({
    id: feeVariants.rushOrder.variantId,
    quantity: 1
  });

}

    /* =========================
       TOTALS
    ========================= */

    const subtotal =
  baseTotal +
  layerCost +
  stainCost +
  textCost +
  colorCost +
  detailCost +
  logoCost +
  imageSizeCost;

    const finalTotal =
  subtotal + rushCost;

    /* =========================
       UI
    ========================= */

    if (els.basePriceEl) {
      els.basePriceEl.textContent =
        currency + baseTotal.toFixed(2);
    }

    if (els.layerCostEl) {
      els.layerCostEl.textContent =
        currency + layerCost.toFixed(2);
    }

    if (els.stainCostEl) {
      els.stainCostEl.textContent =
        currency + stainCost.toFixed(2);
    }

    if (els.textCostEl) {
      els.textCostEl.textContent =
        currency + textCost.toFixed(2);
    }

    if (els.colorCostEl) {
      els.colorCostEl.textContent =
        currency + colorCost.toFixed(2);
    }
    const imageSizeCostEl =
  document.getElementById(
    "imageSizeCost"
  );

if (imageSizeCostEl) {

  imageSizeCostEl.textContent =
    currency +
    imageSizeCost.toFixed(2);

}

    if (els.detailCostEl) {
      els.detailCostEl.textContent =
        currency + detailCost.toFixed(2);
    }

    if (els.rushCostEl) {
      els.rushCostEl.textContent =
        currency + rushCost.toFixed(2);
    }

    if (els.totalEl) {
      els.totalEl.textContent =
        currency + finalTotal.toFixed(2);
    }

    window.currentBaseItem = {
  id: baseVariantId,
  quantity: 1
};
const dedupedVariants =
  selectedAddonVariants.filter(
    (item, index, self) =>
      index ===
      self.findIndex(
        v => v.id === item.id
      )
  );
    window.selectedAddonVariants =
  dedupedVariants;
  console.log(
  "Addon Variants:",
  JSON.stringify(
    window.selectedAddonVariants,
    null,
    2
  )
);

    window.currentTextVariant =
      textVariant;

    window.currentLogoVariant =
      logoVariant;
   window.lastCalculatedPrice = finalTotal;



    updateColorUI();

    updateLiveSummary();

    updateCartProperties();

}


  /* =========================
     INIT
  ========================= */

  function init() {

    const els = getEls();

    [
      els.sizeSelector,
      els.woodType,
      els.layerSelector,
      els.stainSelector,
      els.textStyle,
      els.rushOrder,
      els.detailToggle
    ].forEach(el => {

      if (!el) return;

      el.addEventListener(
        "change",
        updatePrice
      );

    });

    if (els.textInput) {
      els.textInput.addEventListener(
        "input",
        updatePrice
      );
    }

    if (els.textSizeSlider) {
      els.textSizeSlider.addEventListener(
        "input",
        updatePrice
      );
    }
    if (els.imageSizeSlider) {

  els.imageSizeSlider.addEventListener(
    "input",
    updatePrice
  );

}

    updatePrice();

  }

  return {
    init,
    updatePrice,
    updateColorUI,
    getLogoTier,
    updateLiveSummary,
    updateCartProperties
  };

})();
